import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useSettings, buildWaLink } from "../lib/SettingsContext";
import { trackWhatsAppLead } from "../lib/AnalyticsInjector";

/**
 * Floating WhatsApp button - appears after 2s with entry animation,
 * then bounce animation repeats. Hover reveals CTA text.
 */
export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);
  const [bouncing, setBouncing] = useState(false);
  const { settings } = useSettings();

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setBouncing(true), 600);
    }, 2000);
    return () => clearTimeout(showTimer);
  }, []);

  if (!visible) return null;

  return (
    <a
      href={buildWaLink(settings)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppLead("float-button")}
      aria-label={settings.wa_cta_float || settings.wa_cta_text}
      data-testid="whatsapp-float-button"
      className="fixed z-50 bottom-6 right-6 md:bottom-8 md:right-8 group wa-float-enter"
    >
      <div className="relative flex items-center">
        <span
          className="hidden md:block absolute right-full mr-3 whitespace-nowrap rounded-full bg-[#0F0F0F] text-white px-5 py-3 text-sm font-medium shadow-xl opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
          data-testid="whatsapp-cta-label"
        >
          {settings.wa_cta_float || settings.wa_cta_text}
        </span>

        <span className="absolute inset-0 rounded-full bg-[#25D366] wa-pulse-ring" aria-hidden="true" />

        <span
          className={`relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white shadow-2xl shadow-emerald-500/30 transition-colors ${
            bouncing ? "wa-float-bounce" : ""
          }`}
        >
          <MessageCircle className="w-7 h-7 md:w-8 md:h-8" strokeWidth={2} />
        </span>
      </div>

      <span
        className="md:hidden absolute -top-10 right-0 whitespace-nowrap rounded-full bg-[#0F0F0F] text-white px-3 py-1.5 text-xs font-medium shadow-lg"
        data-testid="whatsapp-cta-label-mobile"
      >
        Hitung Kredit
      </span>
    </a>
  );
}
